import React, { useState,useEffect   } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Users,
  Clapperboard,
  Star,
  CheckCircle,
  TrendingUp,
  MoreVertical,
  Plus,
  Eye,
  Film,
  Video
} from "lucide-react";
import {
  BarChart,
  Bar,
    Cell,
//   LineChart,
// Line,
Legend,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import "./CastingDirectorDashboard.css";
import { fetchCastingDirectorDashboardApi } from "../../../services/api";

const CastingDirectorDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("all");
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showBars, setShowBars] = useState(true);
  useEffect(() => {

  fetchDashboard();

}, []);
const filteredApplications =
  activeTab === "all"
    ? dashboardData?.recentApplications || []
    : dashboardData?.recentApplications?.filter((item) => {
        const status = item.status?.toLowerCase();
        if (activeTab === "pending") {
          return status === "pending";
        }
        if (activeTab === "shortlisted") {
          return (
            status === "shortlisted" ||
            status === "selected"
          );
        }
        return true;
      }) || [];

const fetchDashboard = async () => {

  try {

    const response =
    await fetchCastingDirectorDashboardApi();

    setDashboardData(
      response.data.data
    );

  } catch (error) {

    console.log(error);

  } finally {

    setLoading(false);

  }

};

  const getStatusBadge = (status) => {
    const s = status.toLowerCase();
    if (s === "pending" || s === "applied") return <span className="cdd-badge badge-yellow">{status}</span>;
    if (s === "reviewed") return <span className="cdd-badge badge-blue">Reviewed</span>;
    if (s === "shortlisted") return <span className="cdd-badge badge-green">Shortlisted</span>;
    if (s === "rejected") return <span className="cdd-badge badge-red">Rejected</span>;
    return <span className="cdd-badge badge-gray">{status}</span>;
  };

  const getTypeBadge = (type) => {
    const t = type.toUpperCase();
    if (t.includes("ONLINE")) return <span className="cdd-type-badge type-online"><Video size={12}/> Online</span>;
    if (t.includes("SLOT_BOOKING") || t.includes("WALK")) return <span className="cdd-type-badge type-walkin">Walk In</span>;
    return <span className="cdd-type-badge type-gray">{type}</span>;
  };

  return (
    <div className="cdd-wrapper">
      <div className="cdd-container">
        
        {/* HEADER */}
        <div className="cdd-header">
          <div>
            <h1 className="cdd-title">Casting Dashboard</h1>
            <p className="cdd-subtitle">Manage your projects, roles, and review incoming talent.</p>
          </div>
          <button className="cdd-btn-primary" onClick={() => navigate('/dashboard/post-roles')}>
            <Plus size={18} /> Post New Role
          </button>
        </div>

        {/* KPI CARDS */}
        <div className="cdd-kpi-grid">
          {[
            {
              title: "Total Projects",
              value:
                dashboardData?.kpis?.totalProjects || 0,
              icon: <Clapperboard />,
              trend: "+2 this month"
            },

            {
              title: "Active Roles",
              value:
                dashboardData?.kpis?.activeRoles || 0,
              icon: <Film />,
              trend: "Active"
            },

            {
              title: "Total Applicants",
              value:
                dashboardData?.kpis?.totalApplicants || 0,
              icon: <Users />,
              trend: "+15%"
            },

            {
              title: "Shortlisted",
              value:
                dashboardData?.kpis?.shortlisted || 0,
              icon: <Star />,
              trend: "Selected"
            }

          ].map((kpi, index) => (
            <div className="cdd-kpi-card" key={index}>
              <div className="cdd-kpi-top">
                <div className="cdd-kpi-icon">{kpi.icon}</div>
                <div className="cdd-kpi-trend">
                  <TrendingUp size={14} /> <span>{kpi.trend}</span>
                </div>
              </div>
              <h3 className="cdd-kpi-value">{kpi.value}</h3>
              <p className="cdd-kpi-label">{kpi.title}</p>
            </div>
          ))}
        </div>

        {/* MIDDLE SECTION: CHART & ACTIVE ROLES */}
        <div className="cdd-middle-grid">
          
          {/* APPLICANT CHART */}
          <div className="cdd-card cdd-chart-card">
            <div className="cdd-card-header">
              <h2>Applicants Overview</h2>
              <select className="cdd-select">
                <option>Last 7 Days</option>
                <option>This Month</option>
              </select>
            </div>
            <div className="cdd-chart-container">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={dashboardData?.chartData || []}  barGap={8}barCategoryGap="20%"  margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                {/* <BarChart data={dashboardData?.chartData || []}  barGap={8}barCategoryGap={window.innerWidth <= 480 ? "35%" : "20%"}  margin={{ top: 10, right: 10, left: -20, bottom: 0 }}> */}
                  <CartesianGrid className="cdd-chart-grid" strokeDasharray="3 3" vertical={false} />

                  <XAxis
                    dataKey="name"
                    tickLine={false}
                    axisLine={false}
                    className="cdd-chart-xaxis"
                    tick={({ x, y, payload }) => {
                      const item = dashboardData?.chartData?.find(
                        (d) => d.name === payload.value
                      );

                      return (
                        <g transform={`translate(${x},${y})`}>
                          <text x={0} y={0} dy={16} textAnchor="middle" className="cdd-chart-label"></text>
                         <text x={0} y={18} dy={16} textAnchor="middle" className="cdd-chart-count">{item?.value ?? 0}</text>
                        </g>
                      );
                    }}
                  />
                  <YAxis tickLine={false} axisLine={false} className="cdd-chart-yaxis" />             
                <Tooltip formatter={(value) => [value, "Count"]} cursor={{ fill: "rgba(255,255,255,0.05)" }}
                  contentStyle={{ background: "var(--cdd-tooltip-bg)", border: "1px solid var(--cdd-tooltip-border)",borderRadius: "12px", color: "var(--cdd-tooltip-text)"}}
                  itemStyle={{color: "var(--cdd-tooltip-text)"}} />
                 <div className="cdd-graph-toggle" onClick={() => setShowBars(!showBars)}>
                  <div className="cdd-graph-toggle-box" />
                    <span className="cdd-graph-toggle-text">{showBars ? "Hide Graph" : "Show Graph"} </span>
                  </div>
                  {/* <Bar dataKey="value" radius={[6, 6, 0, 0]} barSize={window.innerWidth <= 480 ? 28 : 45} minPointSize={4}> */}
                  <Bar dataKey="value" radius={[6, 6, 0, 0]} barSize={45} minPointSize={4}>
                    {
                        (dashboardData?.chartData || []).map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={entry.fill}
                          />
                        ))
                      }
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* ACTIVE ROLES LIST */}
          <div className="cdd-card cdd-roles-card">
            <div className="cdd-card-header">
              <h2>My Active Roles</h2>
              <Link to="/dashboard/roles" className="cdd-link-btn">View All</Link>
            </div>
            <div className="cdd-roles-list">
              {/* {mockActiveRoles.map((role) => ( */}
              {dashboardData?.activeRoles?.map((role) => (
                <div className="cdd-role-item" key={role.id}>
                  <div className="cdd-role-info">
                    <div className="cdd-role-icon-small"><Film size={16} /></div>
                    <div>
                      <h4 className="cdd-role-title">{role.title}</h4>
                      <p className="cdd-role-project">{role.project}</p>
                    </div>
                  </div>
                  <div className="cdd-role-stats">
                    <div className="cdd-applicant-count">
                      <strong>{role.applicants}</strong>
                      <span>Applicants</span>
                    </div>
                    <button className="cdd-icon-btn"><MoreVertical size={16} /></button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* BOTTOM SECTION: RECENT AUDITIONS TABLE */}
        <div className="cdd-card cdd-table-card">
          <div className="cdd-card-header">
            <h2>Recent Applications</h2>
            <div className="cdd-table-filters">
              <button className={activeTab === "all" ? "active" : ""} onClick={() => setActiveTab("all")}>All</button>
              <button className={activeTab === "pending" ? "active" : ""} onClick={() => setActiveTab("pending")}>Pending</button>
              <button className={activeTab === "shortlisted" ? "active" : ""} onClick={() => setActiveTab("shortlisted")}>Shortlisted</button>
            </div>
          </div>

          <div className="cdd-table-responsive">
            <table className="cdd-table">
              <thead>
                <tr>
                  <th>DATE</th>
                  <th>CANDIDATE NAME</th>
                  <th>ROLE TITLE</th>
                  <th>PROJECT</th>
                  <th>TYPE</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {/* {mockAuditions.map((row) => ( */}
                {/* {dashboardData?.recentApplications?.map((row) => ( */}
                {filteredApplications.map((row) => (
                  // <tr key={row.id}>
                  <tr key={row.id || row.roleApplicationId}>
                    <td className="cdd-text-muted">{row.date}</td>
                    <td>
                      <div className="cdd-candidate-cell">
                        <div className="cdd-avatar">{row.candidate.charAt(0)}</div>
                        <span className="cdd-candidate-name">{row.candidate}</span>
                      </div>
                    </td>
                    <td className="cdd-font-medium">{row.role}</td>
                    <td className="cdd-text-muted">{row.project}</td>
                    <td>{getTypeBadge(row.type)}</td>
                    <td>{getStatusBadge(row.status)}</td>
                    <td>
                         <button
                            className="cdd-action-btn"
                            title="View Application"
                          onClick={() =>
                          navigate(
                            `/dashboard/manage-applications/${row.id}`
                          )
                        }
                          >
                            <Eye size={18} />
                          </button>
                      </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
};

export default CastingDirectorDashboard;